// extracted by mini-css-extract-plugin
module.exports = {"snapshot":"SnapshotSelector_snapshot__3T43n","dropdown-item":"SnapshotSelector_dropdown-item__34USS"};